export default __webpack_public_path__ + "static/media/txt_title3.253f9cda.svg";